// Minimum one letter, one number and one special character, with total length of 8
export const isPassword = (string) => {
  return !!string?.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)
}
